import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { usePlan } from "../context/PlanContext";

/**
 * Rota que exige um recurso do plano. Quem chega pela URL direta sem ter o
 * recurso cai na tela de planos com o motivo, em vez de ver a pagina vazia
 * ou uma sequencia de erros 402 vindos da API.
 */
const FeatureRoute = ({ feature, children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { carregando, temRecurso } = usePlan();

  if (loading || carregando) {
    return <div style={{ padding: 24 }}>Carregando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!temRecurso(feature)) {
    return <Navigate to={`/planos?recurso=${feature}`} replace />;
  }

  return children;
};

export default FeatureRoute;
